<template>
  <BaseBottomSheet
    :title="headerText"
    screen-name="help_and_support_bottom_sheet"
  >
    <template #trigger="{ open }">
      <BaseButton
        size="small"
        variant="ghost"
        @click="open"
      >
        <template #prepend>
          <QuestionMarkIcon />
        </template>
        <p
          class="kds-typography-interactive-medium kds-color-text-interactive-accent"
        >
          {{ $t('generic__help') }}
        </p>
      </BaseButton>
    </template>
    <div
      class="kds-content-block header-help-eu"
      data-qa="help-and-support"
    >
      <div
        class="kds-typography-paragraph-large"
        v-html="descriptionText"
      />
      <BaseButton
        :text="$t('eu__help_and_support__email_v9.5.0')"
        data-qa="help-and-support-mailto"
        variant="outlined"
        @click="handleEmailClick"
      />
      <BaseButton
        :text="$t('eu__help_and_support__hotline_v9.5.0')"
        data-qa="help-and-support-call"
        variant="outlined"
        @click="handlePhoneCallClick"
      />
      <div class="kds-typography-paragraph-large header-help-eu__office-hours">
        {{ supportHintText }}
      </div>
    </div>
  </BaseBottomSheet>
</template>
<script setup>
import BaseButton from '@shared/components/BaseButton.vue'
import QuestionMarkIcon from '@shared/assets/icon/QuestionMarkIcon.vue'
import BaseBottomSheet from '@shared/components/BaseBottomSheet.vue'
import { computed } from 'vue'
import env from '@shared/env.js'
import { useI18n } from 'petite-vue-i18n'
import Tracker from '@shared/Tracker.js'

const { t } = useI18n()

const phoneNumber = computed(() => t('eu__support__phone_number'))
const rawPhoneNumber = phoneNumber.value.replace(/\s/g, '')

const supportHintText = computed(() =>
  t('eu__prescription_support__hint', { phone_number: phoneNumber.value }),
)

const appName = computed(() => {
  switch (env.VITE_DISEASE) {
    case 'COPD':
      return t('eu__generic_copd_app')
    default:
      return t('eu__generic_msk_app')
  }
})

const mailTo = computed(
  () =>
    `mailto:${env.VITE_SUPPORT_EMAIL}?subject=${encodeURIComponent(appName.value)}`,
)

const headerText = computed(() => {
  if (!env.features.diga) {
    return t('eu__help_and_support__header__diga_disabled')
  }

  return t('eu__help_and_support__header_v9.5.0')
})

const descriptionText = computed(() => {
  if (!env.features.diga) {
    return t('eu__help_and_support__description__diga_disabled')
  }

  return t('eu__help_and_support__description_v9.5.0', {
    app_name: appName.value,
  })
})

const handlePhoneCallClick = () => {
  Tracker.trackButtonSelect('call_hotline')

  const tag = document.createElement('a')
  tag.href = `tel:${rawPhoneNumber}`
  tag.click()
}

const handleEmailClick = () => {
  Tracker.trackButtonSelect('write_email')

  const tag = document.createElement('a')
  tag.href = mailTo.value
  tag.click()
}
</script>

<style lang="scss" scoped>
.header-help-eu {
  &__office-hours {
    margin: auto;
  }
}
</style>
